
import { Component, Emit, Prop, mixins } from 'nuxt-property-decorator'
import { units as defaultUnits } from '@/params/constants'
import { Unit } from '@/params/types'
import { Debounce } from 'vue-debounce-decorator'
import ChainMixin from '@/utils/mixins/chainMixin'
import { NeoField, NeoInput } from '@kodadot1/brick'

@Component({
  components: {
    NeoField,
    NeoInput,
  },
})
export default class ReadOnlyBalanceInput extends mixins(ChainMixin) {
  @Prop({ type: [Number, String], default: 0 }) value!: number
  protected units: Unit[] = defaultUnits
  private selectedUnit = 1
  @Prop({ default: 'USD' }) public label!: string
  @Prop({ default: 'balance' }) public labelInput!: string

  get inputValue(): number {
    return this.value
  }

  set inputValue(value: number) {
    this.handleInput(value)
  }

  formatSelectedValue(value: number): number {
    return value * 10 ** this.decimals * this.selectedUnit
  }

  protected mapper(unit: Unit) {
    if (unit.name === '-') {
      return { ...unit, name: this.unit }
    }
    return unit
  }

  public mounted() {
    this.units = defaultUnits.map(this.mapper)
  }

  @Debounce(200)
  @Emit('input')
  public handleInput(value: number) {
    return value
  }
}
